import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#011911' // Vert foncé
    },
    secondary: {
      main: '#e7dfc6', // beige doux
    },
    focus: {
      main: '#843b62', // magenta
    },
    focus2: {
      main: '#2ab7ca', // bleu clair
    },
    grey: {
      main: '#E0E0E0', // Gris clair
    },
    validation:{
      main: '#A3B18A', // Vert sauge
    },
    alerte:{
      main: '#fe4a49', // Rouge doux
    },
    background: {
      default: '#e7dfc6', // Beige doux
      paper: '#ffffff', // Blanc pour les cartes et les dialogues
    },
  },
  typography: {
    fontFamily: 'Merriweather Sans, Inter, Roboto, Arial, sans-serif',
    lineHeight: 1.5,
    h1: {
      fontFamily: 'Merriweather Sans, sans-serif',
      fontWeight: 600,
      fontSize: '52px',
      color: '#011911', // Bleu nuit
      '@media (max-width:600px)': {
        fontSize: '34px',
      },
    },
    h2: {
      fontFamily: 'Merriweather Sans, sans-serif',
      fontWeight: 500,
      fontSize: '34px',
      color: '#011911', // Bleu nuit
      '@media (max-width:600px)': {
        fontSize: '28px',
      },
    },
    h3: {
      fontFamily: 'Merriweather Sans, sans-serif',
      fontWeight: 500,
      fontSize: '30px',
      color: '#011911', // Bleu nuit
      '@media (max-width:600px)': {
        fontSize: '26px',
      },
    },
    h4: {
      fontFamily: 'Merriweather Sans, sans-serif',
      fontWeight: 500,
      fontSize: '26px',
      color: '#011911', // Bleu nuit
      '@media (max-width:600px)': {
        fontSize: '22px',
      },
    },
    subtitle2:{
      fontFamily: 'Inter, Merriweather Sans, Roboto, sans-serif',
      fontSize: '20px',
      fontWeight: 500,
      '@media (max-width:600px)': {
        fontSize: '18px',
      },
    },
    subtitle3:{
      fontFamily: 'Inter, Merriweather Sans, Roboto, sans-serif',
      fontSize: '18px',
      fontWeight: 500,
      '@media (max-width:600px)': {
        fontSize: '16px',
      },
    },
    body1:{
      fontFamily: 'Inter, Merriweather Sans, Roboto, sans-serif',
      fontSize: '20px',
      fontWeight: 400,
      color: 'black',
      '@media (max-width:600px)': {
        fontSize: '16px',
      },
    },
    body3:{
      fontFamily: 'Inter, Merriweather Sans, Roboto, sans-serif',
      fontSize: '16px',
      fontWeight: 400,
      '@media (max-width:600px)': {
        fontSize: '14px',
      },
    },
    button: {
      fontFamily: 'Merriweather Sans, Roboto, sans-serif',
      fontSize: '18px',
      fontWeight: 500,
      color: '#f5f1eb',
      textTransform: 'none', // Pas de majuscules automatiques
      '@media (max-width:600px)': {
        fontSize: '14px',
      },
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Pas de majuscules automatiques
          borderRadius: '10px', // Bordure arrondie
          px:3,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '10px', // Bordure arrondie pour les cartes
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // Ombre légère
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '10px', // Bordure arrondie pour les dialogues
          padding: '10px', // Espacement interne
          backgroundColor: '#ffffff', // Fond blanc pour les dialogues
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: '10px', // Bordure arrondie pour les sélecteurs
          '& .MuiSelect-icon': {
            color: '#1E2A38', // Couleur de l'icône du sélecteur
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: '10px', // Bordure arrondie pour les champs de texte
          '& .MuiInputBase-root': {
            borderRadius: '10px', // Bordure arrondie pour la racine du champ de texte
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1E2A38', // Couleur de la bordure au focus
          },
          '& .MuiInputLabel-root': {
            color: '#1E2A38', // Couleur de l'étiquette du champ de texte
          }
        }
      }
    }
  },
});

export default theme;